import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { checkRoutePermission } from './RoutePermissions';

const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    
    useEffect(() => {
        const hasAccess = checkRoutePermission(location.pathname);
        
        if (!hasAccess) {
            // Redirect to a custom 404 page with permission denied info
            navigate('/404', { 
                replace: true, 
                state: { 
                    permissionDenied: true, 
                    originalPath: location.pathname 
                } 
            });
        }
    }, [location.pathname, navigate]);
    
    // Check permission before rendering
    const hasAccess = checkRoutePermission(location.pathname);
    
    if (!hasAccess) {
        return null; // Don't render anything while redirecting
    }
    
    return children;
};

export default ProtectedRoute;